import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Row } from "reactstrap";

class FromToDate extends React.Component {
    render() { 
        return (
          <Row>
            <Col sm="12" className="depart-arrive">
              <Row className="py-3">
                <Col sm="4" className="depart-date">
                  <div className="date-title">Départ</div>
                  <div className="date-numbr">18</div>
                  <div className="month">aout</div>
                </Col>
                <Col sm="2">
                  <span className="arrow-date">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      style={{ marginTop: "55px" }}
                    ></FontAwesomeIcon>
                  </span>
                </Col>
                <Col sm="4" className="arrive-date">
                  <div className="date-title">Arrivé</div>
                  <div className="date-numbr">26</div>
                  <div className="month">septembre</div>
                </Col>
              </Row>
            </Col>
          </Row>
        );
    }
}
 
export default FromToDate;